import { as } from 'folds';
import classNames from 'classnames';
import { Avatar, AvatarShape } from '$components/avatar';
import type { Shape } from '$components/silhouette';
import * as css from './styles.css';

type StackedAvatarProps = {
  shape?: Shape;
};

export const StackedAvatar = as<'span', css.StackedAvatarVariants & StackedAvatarProps>(
  ({ size, variant, className, shape = AvatarShape.Circle, ...props }, ref) => (
    <Avatar
      size={size}
      shape={shape}
      className={classNames(css.StackedAvatar({ size, variant }), className)}
      {...props}
      ref={ref}
    />
  )
);
